import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import {
    OrderStep,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import requests from 'app/requests/Order/ReverseLogistic.requests'
import {
    AutomaticallyFormType,
} from '../../../createAutomaticallyForm.types'

const useGetOrderSteps = ({
    bestOption,
    ...rest
}: Partial<AutomaticallyFormType>) => {
    return useRequest<OrderStep[]>({
        key: RequestKeys.getPopulationOrderStep,
        params: {
            params: {
                optionSelected: bestOption,
                request: rest,
            },
        },
        requestFunc: RequestFn.getEntity(requests.populateOrderStep),
    })
}

export default useGetOrderSteps
